<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>

        </div>

       <div class="content" v-else>

               <h1 v-if="type === 'add'">
                    Vytváření kategorie
               </h1>
               <h1 v-else>
                    Detail kategorie
               </h1>


           <v-layout>
               <table class="info-table">
                   <tr>
                       <td class="info-table__title">
                           Náhledový obrázek:
                       </td>
                       <td class="info-table__value">
                           <div v-if="!imageUploaded">
                               <div class="image image--loader">
                                   <div class="loader">
                                       <div class="loader__item">
                                       </div>
                                       <div class="loader__text">Nahrávání</div>
                                   </div>
                               </div>
                           </div>
                           <div v-else>
                               <div class="image image--data" v-if="data.image" :style="'background-image:url('+data.image+')'">
                               </div>
                               <div class="image image--empty" v-else>
                               </div>
                           </div>

                           <div class="image-controls" v-if="imageUploaded">
                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="!data.image"
                                       color="primary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat
                               </v-btn>
                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="data.image"
                                       color="secondary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat jiný
                               </v-btn>
                               <v-btn
                                       @click="removeCoverImage()"
                                       v-if="data.image"
                                       color="error"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Smazat
                               </v-btn>
                           </div>
                           <div class="info-table__hint">
                               Doporučený rozměr: 648 × 850 px
                           </div>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Alt:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--larger"
                                   outlined
                                   @input="errors.image_alt = ''"
                                   v-model="data.image_alt"
                                   :error-messages="makeError(errors.image_alt)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr v-if="type !== 'add'">
                       <td class="info-table__title">
                           ID:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   disabled
                                   class="input--small"
                                   outlined
                                   v-model="data.id"
                                   @input="errors.id = ''"
                                   :error-messages="makeError(errors.id)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Název: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.name"
                                   @input="errors.name = ''"
                                   :error-messages="makeError(errors.name)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Slug: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.slug"
                                   @input="errors.slug = ''"
                                   :error-messages="makeError(errors.slug)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Nadřazená kategorie:
                       </td>
                       <td class="info-table__value">
                           <v-autocomplete
                                   class="input--small"
                                   outlined
                                   clearable
                                   v-model="data.parent_id"
                                   :items="parentOptions"
                                   item-text="name"
                                   item-value="id"
                                   @input="errors.parent_id = ''"
                                   :error-messages="makeError(errors.parent_id)"
                           >
                           </v-autocomplete>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <tiptap-vuetify
                                   class="wysiwyg wysiwyg--from-book"
                                   v-bind:class="{'wysiwyg--error':errors.description}"
                                   @input="errors.description = ''"
                                   v-model="data.description"
                                   :extensions="extensions"
                           />
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Publikováno:
                       </td>
                       <td class="info-table__value">
                           <v-checkbox
                                   class="input--small"
                                   outlined
                                   v-model="data.published"
                                   @input="errors.published = ''"
                                   :error-messages="makeError(errors.published)"
                           >
                           </v-checkbox>
                       </td>
                   </tr>
                   <tr v-if="!data.parent_id">
                       <td class="info-table__title">
                           Vybrané audioknihy na kategorii (max 3):
                       </td>
                       <td class="info-table__value">
                           <v-autocomplete
                                   class="input--larger"
                                   outlined
                                   multiple
                                   chips
                                   deletable-chips
                                   v-model="data.featured_audiobook_ids"
                                   :items="audiobookOptions"
                                   item-text="name"
                                   item-value="id"
                                   @input="errors.featured_audiobook_ids = ''"
                                   :error-messages="makeError(errors.featured_audiobook_ids)"
                           >
                           </v-autocomplete>

                           <draggable
                                   v-if="data.featured_audiobook_ids && data.featured_audiobook_ids.length > 0"
                                   v-model="data.featured_audiobook_ids"
                                   tag="table"
                                   class="info-table"
                                   handle=".featured-audiobook-drag-handle"
                           >
                               <tr
                                       v-for="(audiobookId, index) in data.featured_audiobook_ids"
                                       :key="audiobookId"
                               >
                                   <td class="featured-audiobook-drag-handle" style="cursor: move;">
                                       <v-icon>drag_indicator</v-icon>
                                   </td>
                                   <td class="small bold">{{ index + 1 }}.</td>
                                   <td>{{ audiobookName(audiobookId) }}</td>
                               </tr>
                           </draggable>
                       </td>
                   </tr>
               </table>

           </v-layout>

           <h2>SEO</h2>
           <v-layout>

               <table class="info-table">

                   <tr>
                       <td class="info-table__title">
                           Titulek:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.seo_title = ''"
                                   v-model="data.seo_title"
                                   :error-messages="makeError(errors.seo_title)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis:
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   @input="errors.seo_meta = ''"
                                   v-model="data.seo_meta"
                                   :error-messages="makeError(errors.seo_meta)"
                           >
                           </v-textarea>
                       </td>
                   </tr>
               </table>
           </v-layout>
           <v-layout>
               <div class="controls-table">
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="addCategory()"
                           v-if="type === 'add'
                    ">
                       Vytvořit
                   </v-btn>
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="editCategory()"
                           v-else
                    >
                       Uložit
                   </v-btn>
                   <v-btn
                           color="error"
                           class="button--control"
                           @click="openDialogDelete()"
                           v-if="type !== 'add'"
                   >
                       Smazat
                   </v-btn>
               </div>
           </v-layout>

           <v-dialog v-model="dialogDelete" persistent>
               <v-card>
                   <v-card-title class="headline">Smazání kategorie</v-card-title>
                   <v-card-text>
                       Opravdu si přejete smazat kategorii <strong>{{data.name}}</strong>?
                   </v-card-text>
                   <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn
                               color="empty"
                               class="button--dialog"
                               @click="closeDialogDelete()"
                       >
                           zrušit
                       </v-btn>
                       <v-btn
                               color="error"
                               class="button--dialog"
                               @click="deleteCategory()"
                       >
                           smazat
                       </v-btn>
                       <v-spacer></v-spacer>
                   </v-card-actions>
               </v-card>
           </v-dialog>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Image } from 'tiptap-vuetify'
    import draggable from 'vuedraggable';

    export default {
        name: 'CategoriesDetail',
        components: {
            TiptapVuetify,
            draggable
        },

        data() {
            return {
                imageUploaded: true,
                dialogDelete: false,
                type: 'add',
                loaded: false,
                data: {},
                errors: {},
                parentOptions: [],
                audiobookOptions: [],
                extensions: [
                    History,
                    Link,
                    Underline,
                    Strike,
                    Italic,
                    ListItem,
                    BulletList,
                    OrderedList,
                    [Heading, {
                        options: {
                            levels: [2, 3]
                        }
                    }],
                    Bold,
                    Paragraph,
                    HardBreak,
                    Image
                ],
            }
        },

        created() {
            const vm = this;
            this.$root.$on('upload-category-image', () => {
                vm.imageUploaded = false;
                vm.$forceUpdate();
            });

            this.$root.$on('uploaded-category-image', (response) => {
                vm.data.image = response.url;
                vm.data.image_id = response.id;
                vm.imageUploaded = true;
                vm.$forceUpdate();
            });

            this.fetchParentOptions();
            this.fetchAudiobookOptions();
            this.fetchData();
        },
        computed: {
            ...mapState(['profile']),
        },
        mounted(){
        },
        methods: {
            selectCoverImage(){
                this.$root.$emit('select-category-image');
            },
            removeCoverImage(){
                this.data.image_id = null;
                this.data.image = null;
                this.$forceUpdate();
            },
            audiobookName(audiobookId){
                const audiobook = this.audiobookOptions.find((a) => a.id === audiobookId);
                return audiobook ? audiobook.name : audiobookId;
            },
            makeError(item){
                if(item === 'required'){
                    return 'Toto pole je povinné';
                }else if(item === 'already_used'){
                    return 'Je již používaný';
                }else if(item === 'not_valid'){
                    return 'Neplatný formát';
                }else if(item === 'max_3'){
                    return 'Maximálně 3 audioknihy';
                }else if(item){
                    return 'Neznámá chyba';
                }else{
                    return '';
                }

            },
            openDialogDelete(){
                this.dialogDelete = true;
            },
            closeDialogDelete(){
                this.dialogDelete = false;
            },

            addCategory(){
                this.loaded = false;
                const request = this.data;
                this.$axios.post('/admin/categories/add', request).then((response) => {
                    this.$router.push({name: 'Categories'});
                }).catch((e) => {
                    if(e.response.data.error_inputs){
                        this.errors = e.response.data.error_inputs
                    }
                    this.loaded = true;
                });
            },
            editCategory(){
                this.loaded = false;
                const request = this.data;
                this.$axios.put('/admin/categories/'+this.$route.params.id+'/edit', request).then((response) => {
                    this.$router.push({name: 'Categories'});
                }).catch((e) => {
                    this.errors = e.response.data.error_inputs;
                    this.loaded = true;
                });
            },
            deleteCategory(){
                this.loaded = false;
                const request = this.data;
                this.$axios.delete('/admin/categories/'+this.$route.params.id+'/delete', request).then((response) => {
                    this.$router.push({name: 'Categories'});
                }).catch((e) => {
                    this.loaded = true;
                });
            },
            fetchParentOptions(){
                this.$axios.get('/admin/categories').then((response) => {
                    this.parentOptions = response.data.categories.filter((c) => {
                        return !c.parent_id && c.id !== Number(this.$route.params.id);
                    });
                });
            },
            fetchAudiobookOptions(){
                this.$axios.get('/admin/audiobooks', {params: { pagination: 0, published: 1, sortBy: 'name', order: 'ASC'}}).then((response) => {
                    this.audiobookOptions = response.data.audiobooks.map((it) => {
                        let type = ' (Audiokniha)'
                        if(it.is_ebook) type = ' (E-kniha)'
                        if(it.is_book) type = ' (Kniha)'
                        it.name += type;
                        return it;
                    });
                });
            },
            fetchData(){
                if(this.$route.params.id === 'add'){
                    this.type = 'add';
                    this.data = {featured_audiobook_ids: []};
                    this.loaded = true;
                }else{
                    this.type = 'detail';
                    this.$axios.get('/admin/categories/' + this.$route.params.id).then((response) => {
                        this.type = 'detail';
                        this.data = response.data.category;
                        if (!this.data.featured_audiobook_ids) {
                            this.data.featured_audiobook_ids = [];
                        }
                        this.loaded = true;
                    }).catch((e) => {
                        this.loaded = true;
                    });
                }
            },



        },
        watch: {


        }
    }
</script>


<style lang="scss">


</style>
